import React, { useEffect, useState } from "react";
import axios from "axios";
import { getCustomerSession,mergeCustomerSession } from "../../utils/applyFlowSession";
const BANK_ANALYZER_URL ="https://fundswalla.in/Api/TaskApi/bankBre";

const AACallbackPage = ({ setScreen }) => {
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("checking");
  const [message, setMessage] = useState("Processing Account Aggregator data...");
  const [callbackData, setCallbackData] = useState(null);

  useEffect(() => {
    const handleAACallback = async () => {
      try {
        console.log("=================================");
        console.log("ACCOUNT AGGREGATOR CALLBACK PAGE");
        console.log("=================================");

        // URL parameters
        const params = new URLSearchParams(window.location.search);

        const leadId =
          params.get("lead_id") ||
          params.get("leadId") ||
          "";

        const transId =
          params.get("transID") ||
          params.get("trans_id") ||
          params.get("txn_id") ||
          "";

        const reqId =
          params.get("reqID") ||
          params.get("request_id") ||
          params.get("req_id") ||
          "";

        const callbackStatus =
          params.get("status") || "";

        const error =
          params.get("error") ||
          params.get("message") ||
          "";

        const data = {
          leadId,
          transId,
          reqId,
          callbackStatus,
          error,
        };

        console.log("AA CALLBACK URL:", window.location.href);
        console.log("AA CALLBACK DATA:", data);

        setCallbackData(data);

        // ------------------------------------------------
        // BASIC CALLBACK VALIDATION
        // ------------------------------------------------

        if (error) {
          setStatus("failed");
          setMessage(error);
          setLoading(false);
          return;
        }

        // ------------------------------------------------
        // TEMPORARY TEST
        // ------------------------------------------------
        // Abhi backend endpoint final nahi diya gaya hai,
        // isliye sirf callback receive hona verify kar rahe hain.

        if (!leadId && !transId && !reqId) {
          console.warn("No AA callback parameters found");

          setStatus("received");
          setMessage(
            "AA callback page opened, but no callback parameters were received."
          );

          setLoading(false);

          
          return;
        }

        // ------------------------------------------------
        // CALLBACK RECEIVED SUCCESSFULLY
        // ------------------------------------------------

        setStatus("received");
        setMessage(
          "Account Aggregator callback received successfully."
        );

        setLoading(false);

        // ------------------------------------------------
// SEND MESSAGE TO TAB 1
// ------------------------------------------------

if (window.opener && !window.opener.closed) {
  console.log("=================================");
  console.log("SENDING AA COMPLETION TO TAB 1");
  console.log("=================================");

  window.opener.postMessage(
    {
      type: "AA_COMPLETED",
      leadId: leadId,
      transId: transId,
      reqId: reqId,
      status: callbackStatus || "success",
    },
    window.location.origin
  );

  console.log("AA COMPLETION MESSAGE SENT");

  setTimeout(() => {
    console.log("CLOSING AA TAB");
    window.close();
  }, 500);
}

      } catch (error) {
        console.error("AA CALLBACK ERROR:", error);

        setStatus("failed");
        setMessage(
          error?.message ||
            "Unable to process Account Aggregator callback."
        );

        setLoading(false);
      }
    };

    handleAACallback();
  }, []);
// const handleContinue = () => {
//   console.log("=================================");
//   console.log("AA CALLBACK CONTINUE CLICKED");
//   console.log("=================================");

//   console.log("Callback Data:", callbackData);

//   // TEMPORARY TESTING
//   // Abhi Bank Analyzer API nahi lagayi hai.
//   // Testing ke liye next existing screen par ja rahe hain.

// //   setScreen("/apply-new/approved");

// };
const handleContinue = async () => {
  try {
    console.log("=================================");
    console.log("BANK ANALYZER START");
    console.log("=================================");

    setLoading(true);
    setMessage("Processing Bank Analyzer...");


    /*
     * declared_income
     *
     * Abhi tumhari curl mein 0 hai.
     * Isliye pehle testing ke liye 0 bhej rahe hain.
     */
    // const declaredIncome = 0;
    const stored = getCustomerSession() || {};

    const leadId = String(
  callbackData?.leadId ||
  stored?.lead_id ||
  ""
).trim();

    if (!leadId) {
      throw new Error("Lead ID is missing");
    }
const declaredIncome = Number(
  String(
    stored?.monthly_income ||
    stored?.saved_fields?.monthly_income ||
    stored?.saved_fields?.monthlyIncome ||
    0
  ).replace(/,/g, "")
);

console.log(
  "MONTHLY INCOME FROM SESSION:",
  declaredIncome
);

const loanAmount = Number(
  String(
    stored?.loan_amount ||
    stored?.saved_fields?.loan_amount ||
    stored?.saved_fields?.loanAmount ||
    0
  ).replace(/,/g, "")
);

console.log(
  "LOAN AMOUNT FROM SESSION:",
  loanAmount
);

    const payload = {
      lead_id: leadId,
      declared_income: declaredIncome,
        loan_amount: loanAmount,
    };

    console.log(
      "========== BANK ANALYZER PAYLOAD =========="
    );

    console.log(
      JSON.stringify(payload, null, 2)
    );

    const response = await axios.post(
      BANK_ANALYZER_URL,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 30000,
      }
    );

    console.log(
      "========== BANK ANALYZER RESPONSE =========="
    );

    console.log("HTTP STATUS:", response.status);
    console.log("RESPONSE:", response.data);

    /*
     * API success
     */
    // if (
    //   response.status >= 200 &&
    //   response.status < 300 &&
    //   response.data?.status
    // ) {
    //   console.log(
    //     "========== BANK ANALYZER SUCCESS =========="
    //   );

    //   setLoading(false);

    //   setScreen("/apply-new/approved");
   

    //   return;
    // }

    if (
  response.status >= 200 &&
  response.status < 300 &&
  response.data?.status
) {
  console.log(
    "========== BANK ANALYZER SUCCESS =========="
  );

  console.log(
    "BANK BRE DECISION:",
    response.data?.data?.decision
  );

  console.log(
    "BANK BRE DECISION REASON:",
    response.data?.data?.decision_reason
  );

  // Save complete Bank BRE response in session
  // so ApprovedPage can use it.
  mergeCustomerSession({
    bankBreResponse: response.data,
    bank_bre_decision:
      response.data?.data?.decision || "",
    bank_bre_decision_reason:
      response.data?.data?.decision_reason || "",
    bank_bre_loan_amount:
      response.data?.data?.loan_amount || "",
  });

  setLoading(false);

  // Both Approve and Reject will temporarily
  // open ApprovedPage.
  // ApprovedPage will decide what to show.
  setScreen("/apply-new/approved");

  return;
}

    /*
     * API returned response but status false
     */
    throw new Error(
      response.data?.message ||
        "Bank Analyzer failed"
    );

  } catch (error) {
    console.error(
      "========== BANK ANALYZER ERROR =========="
    );

    console.error(error);
    console.error(
      "BANK ANALYZER ERROR RESPONSE:",
      error?.response?.data
    );

    setLoading(false);

    setStatus("failed");

    setMessage(
      error?.response?.data?.message ||
        error?.message ||
        "Unable to process Bank Analyzer"
    );
  }
};
  return (
    
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "30px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "500px",
          padding: "30px",
          borderRadius: "16px",
          background: "#fff",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          textAlign: "center",
        }}
      >
        {loading && (
          <>
            <h2>Processing...</h2>

            <p>
              {message}
            </p>
          </>
        )}

        {!loading && status === "received" && (
          <>
            <h2>Account Aggregator Completed </h2>

            <p>
              {message}
            </p>

            <div style={{marginTop: "20px", padding: "15px",background: "#f7f7f7",borderRadius: "10px",textAlign: "left",fontSize: "14px", }}>
              <p>
                <strong>Lead ID:</strong>{" "}
                {callbackData?.leadId || "Not received"}
              </p>

              <p>
                <strong>Transaction ID:</strong>{" "}
                {callbackData?.transId || "Not received"}
              </p>

              <p>
                <strong>Request ID:</strong>{" "}
                {callbackData?.reqId || "Not received"}
              </p>

              <p>
                <strong>Status:</strong>{" "}
                {callbackData?.callbackStatus || "Not received"}
              </p>
            </div>

           <button
      type="button"
      onClick={handleContinue}
      style={{
        marginTop: "25px",
        padding: "12px 30px",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: "600",
      }}
    >
      Continue
    </button>
          </>
        )}

        {!loading && status === "failed" && (
          <>
            <h2>Account Aggregator Failed</h2>

            <p>{message}</p>

            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{
                marginTop: "20px",
                padding: "12px 24px",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Try Again
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default AACallbackPage;